module.exports = __webpack_public_path__ + "static/media/scarf.b840fade.svg";